import { render, staticRenderFns } from "./OrderShipItemsInputs.vue?vue&type=template&id=0d3ec941&"
import script from "./OrderShipItemsInputs.vue?vue&type=script&lang=ts&"
export * from "./OrderShipItemsInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports